import { makeAutoObservable } from 'mobx';

export class FilterDTO {
    organizations: OrganizationDTO[] = [];

    constructor () {
        makeAutoObservable(this);
    }
}

export type OrganizationDTO = {
    id: string
    name: string
    settings: {
        applications: string[]
    }
}

export enum Role {
    Admin = 'Admin',
    Reader = 'Reader'
}

export type UserDTO = {
    id?: string
    email: string
    organizationId: string
    role: string
    givenName: string
    surname: string
    displayName: string
    jobTitle: string
    phoneNumber: string
}
export type ImportUserDTO = {
    organizationId: string
}
export type SubscriptionsDTO = {
    id: string
    name: string
    features: [
        {
            name: string,
            description: string,
            options: string[]
        }
    ]
}